import { UserCircle2 } from 'lucide-react'

interface CrewLoadSparklineProps {
  startHour: number
  totalHours: number
}

/** Hardcoded mock crew load density bars per hour. */
const MOCK_LOAD: { heightPercent: number; color: string }[] = [
  { heightPercent: 15, color: 'bg-muted' },
  { heightPercent: 35, color: 'bg-blue-300 border-blue-400/50' },
  { heightPercent: 55, color: 'bg-blue-400 border-blue-500/50' },
  { heightPercent: 20, color: 'bg-muted' },
  { heightPercent: 10, color: 'bg-muted' },
  { heightPercent: 90, color: 'bg-red-400 border-red-500' },
  { heightPercent: 60, color: 'bg-amber-300 border-amber-400/50' },
  { heightPercent: 40, color: 'bg-blue-300 border-blue-400/50' },
  { heightPercent: 25, color: 'bg-blue-200 border-blue-300/50' },
  { heightPercent: 15, color: 'bg-muted' },
  { heightPercent: 10, color: 'bg-muted' },
  { heightPercent: 5, color: 'bg-muted' },
  { heightPercent: 5, color: 'bg-muted' },
]

export function CrewLoadSparkline({ startHour, totalHours }: CrewLoadSparklineProps) {
  // Take only as many bars as totalHours
  const bars = MOCK_LOAD.slice(0, totalHours)

  return (
    <div className="flex items-stretch border-t shadow-[0_-2px_6px_-1px_rgba(0,0,0,0.05)] sticky bottom-0 z-30 bg-card">
      {/* Label column */}
      <div className="w-[300px] shrink-0 p-3 border-r bg-muted/30 flex flex-col justify-center">
        <div className="font-bold text-sm tracking-tight flex items-center gap-2 text-muted-foreground">
          <UserCircle2 className="h-4 w-4" />
          Crew Load
        </div>
        <div className="text-[10px] text-muted-foreground mt-0.5">Mock aggregated staff load</div>
      </div>

      {/* Sparkline */}
      <div className="flex-1 flex items-end gap-0.5 h-[64px] p-2 pt-1 bg-gradient-to-t from-muted/30 to-card">
        {bars.map((bar, i) => (
          <div
            key={`${startHour + i}`}
            className={`flex-1 rounded-t border transition-all ${bar.color} group cursor-pointer relative`}
            style={{ height: `${bar.heightPercent}%` }}
          >
            {bar.heightPercent >= 80 && (
              <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-destructive text-destructive-foreground text-[9px] font-bold px-1.5 py-0.5 rounded shadow opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-50">
                Peak Load
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
